"use client";

import {
  addMonths,
  addWeeks,
  endOfMonth,
  format,
  startOfMonth,
  subMonths,
  subWeeks,
} from "date-fns";
import { useCallback, useState } from "react";

export function useCalendar(initialDate?: Date) {
  const [currentDate, setCurrentDate] = useState(initialDate || new Date());

  const goToPreviousMonth = useCallback(() => {
    setCurrentDate((prevDate) => subMonths(prevDate, 1));
  }, []);

  const goToNextMonth = useCallback(() => {
    setCurrentDate((prevDate) => addMonths(prevDate, 1));
  }, []);

  const goToToday = useCallback(() => {
    setCurrentDate(new Date());
  }, []);

  const getMonthRange = useCallback(() => {
    const start = startOfMonth(currentDate);
    const end = endOfMonth(currentDate);
    return {
      start,
      end,
      startStr: format(start, "yyyy-MM-dd"),
      endStr: format(end, "yyyy-MM-dd"),
      monthDisplay: format(currentDate, "MMMM yyyy"),
    };
  }, [currentDate]);

  const goToDate = useCallback((date: Date) => {
    setCurrentDate(date);
  }, []);

  const goToPreviousWeek = useCallback(() => {
    setCurrentDate((prevDate) => subWeeks(prevDate, 1));
  }, []);

  const goToNextWeek = useCallback(() => {
    setCurrentDate((prevDate) => addWeeks(prevDate, 1));
  }, []);

  return {
    currentDate,
    goToPreviousMonth,
    goToNextMonth,
    goToPreviousWeek,
    goToNextWeek,
    goToToday,
    getMonthRange,
    goToDate, // Add goToDate to the returned object
  };
}
